<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgements">
<h1 style="padding-top:150px;">Acknowledgements</h1>
<p>Firstly, I would like to thank the entire team of Austin Macauley for their help and encouragement to publish this book. I also thank my husband and daughter for their love, support and understanding.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch003.vue?0a3bcf72